import styled from 'styled-components';

const SpinnerContainer = styled.div`
  margin: ${({ small }) => (small ? '0' : '60px auto')};
  font-size: ${({ small }) => (small ? '2px' : '10px')};
  position: relative;
  border-top: 1.1em solid rgba(39, 172, 227, 0.2);
  border-right: 1.1em solid rgba(39, 172, 227, 0.2);
  border-bottom: 1.1em solid rgba(39, 172, 227, 0.2);
  border-left: 1.1em solid ${({ theme }) => theme.colors.primary};
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
  border-radius: 50%;
  width: 10em;
  height: 10em;
  ::after {
    border-radius: 50%;
    width: 10em;
    height: 10em;
  }
  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`;

export { SpinnerContainer };
